import {Response} from "@/hooks/services/queries/types";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import logger from "@FRAMEWORK/utils/logger";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type GlobalGoodsLive = {
	dspYn: "Y" | "N"; // 노출여부
	goodsCd: string; // 상품코드
	goodsType: string; // 상품타입 PKG
	liveDt: string; // 라이브 일시 yyyy-mm-dd HH24:mi:ss
	liveId: number; // 라이브 아이디
	liveTime: string; // 라이브 시간
};

/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/
const key = "useGlobalGoodsLive";
const getPath = (): string | null => `${process.env.ENV_SUPPORT_URL}/api/bff/link/global/selectOne`;

/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/
const useGlobalGoodsLive = (goodsCd = "", options?: Partial<UseQueryOptions<Response<GlobalGoodsLive>, Error>>) => {
	try {
		return useQuery({
			queryKey: [key, goodsCd, getPath()],
			queryFn: () => useConfigureAxios({url: getPath(), method: "GET", params: {goodsCd}}).then(r => r.data),
			throwOnError: false,
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};

export default useGlobalGoodsLive;
export {getPath};
export type {GlobalGoodsLive};
